import React, { Component } from 'react';
import Row from './Row'
import { iconEmpty } from './../../../../services/helper'

class Rows extends Component {
    renderRows = () => {
        if(!this.props.confirmItemName.length) {
            return (
                <tr className='not-shipper'>
                    <td colSpan={6}>{iconEmpty()}</td>
                </tr>
            )
        }
        return this.props.confirmItemName.map((e, i) => {
            return <Row     
                key={i}
                data={e}
                keyRow={i+1}
                checked={this.props.checked}
                keyItem={e.key}
            />
        })
    }

    render() {
        return (
            <React.Fragment>{this.renderRows()}</React.Fragment>
        );
    }
}

export default Rows;


// WEBPACK FOOTER //
// ./src/containers/orders/components/translation-item-name/Rows.js